import DragIndicator from '@assets/icons/drag-indicator.svg'
import { Icon } from './Icon'

export const DragIndicatorIcon = Icon(DragIndicator)
